import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useData } from "../../context/DataContext";
import { getMyEmployee } from "../../api/employees";
import { mapEmployeeRow } from "../../utils/dataMappers";
import { resolveMyEmployeeRecord } from "../../utils/homeStatsHelpers";
import EmployeeHistoryView from "../common/EmployeeHistoryView";
import "../common/EmployeeHistoryView.css";

/**
 * Self-service view: logged-in employee sees their own daily
 * attendance, permits, leaves, and penalties.
 */
function MyDaysView({ userRole }) {
  const { user } = useAuth();
  const data = useData();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setError(null);

      const local = resolveMyEmployeeRecord(data.allEmployees || [], user);
      if (local && !cancelled) {
        setEmployee(local);
      }

      if (!user?._fromBackend) {
        if (!cancelled) {
          setLoading(false);
          if (!local) {
            setError("تعذر تحديد ملف الموظف الحالي");
          }
        }
        return;
      }

      try {
        const me = await getMyEmployee();
        if (cancelled) return;
        setEmployee(mapEmployeeRow(me) || me);
      } catch (err) {
        if (cancelled) return;
        if (!local) {
          setError(
            err.response?.data?.message || "تعذر تحميل بيانات الموظف",
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [user, data.allEmployees]);

  if (loading && !employee) {
    return (
      <div className="employee-history" dir="rtl">
        <p className="eh-loading">جاري تحميل أيامك...</p>
      </div>
    );
  }

  if (error && !employee) {
    return (
      <div className="employee-history" dir="rtl">
        <div className="eh-access-denied">
          <h3>تعذر العرض</h3>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="my-days-view" dir="rtl">
      <div className="ess-home-header">
        <h1 className="ess-home-title">أيامي</h1>
        <p className="ess-home-subtitle">
          حضور وانصراف وأذونات وإجازات وجزاءات خلال الشهر
        </p>
      </div>
      <EmployeeHistoryView
        employee={employee}
        userRole={userRole || user?.role}
        selfView
      />
    </div>
  );
}

export default MyDaysView;
